import ColorStyles from '@components/ColorStyles';
import BrToggle from './BrToggle';

BrToggle.ColorStyles = ColorStyles;

export default BrToggle;
